// import {
//   CAMPAIGN_ERROR_MESSAGES,
//   MAX_CONVERSIONS_PERIOD_HOUR,
//   MIN_CONVERSIONS_PERIOD_HOUR,
// } from 'modules/campaigns/lib/constants';
// import { AttributionMode } from 'modules/domains/campaign/types/index';
import { z } from 'zod';
import {
  // APPLY_GOAL_TO_FIELD,
  // ApplyGoalTo,
  // ATTRIBUTION_MODE_FIELD,
  // ATTRIBUTION_MODE_HOURS_FIELD,
  // CAMPAIGN_LABELS_FIELD,
  // MESSAGE_TYPES_FIELD,
  EVENT_NAME_FIELD,
  GOAL_NAME_FIELD,
  GOAL_NAME_MAX_LENGTH,
} from './CreateGoalForm.constants';

const goalNameSchema = z
  .string()
  .min(1, 'Name is required to create a goal.')
  .max(GOAL_NAME_MAX_LENGTH, `Name can't be more than ${GOAL_NAME_MAX_LENGTH} characters.`);
const eventNameSchema = z.string().min(1, 'Metric is required to complete a goal.');

/**
 * The commented out fields are not yet supported.
 */
export const createGoalSchema = z.object({
  [GOAL_NAME_FIELD]: goalNameSchema,
  [EVENT_NAME_FIELD]: eventNameSchema,
  // [ATTRIBUTION_MODE_FIELD]: z.nativeEnum(AttributionMode),
  // [ATTRIBUTION_MODE_HOURS_FIELD]: z.string().optional(),
  // [CAMPAIGN_LABELS_FIELD]: z.string().array().optional(),
  // [MESSAGE_TYPES_FIELD]: z.string().array().optional(),
  // [APPLY_GOAL_TO_FIELD]: z.nativeEnum(ApplyGoalTo).optional(),
});
// .superRefine((data, ctx) => {
//   if (data?.[ATTRIBUTION_MODE_HOURS_FIELD] === '')
//     ctx.addIssue({
//       code: z.ZodIssueCode.custom,
//       message: CAMPAIGN_ERROR_MESSAGES.invalidAttributionPeriodRange,
//       path: [ATTRIBUTION_MODE_HOURS_FIELD],
//     });

//   // we should look at refactoring these into functions that take a failure call back so we can write tests.
//   const isLastMessagedAttributionMode =
//     data?.[ATTRIBUTION_MODE_FIELD] === AttributionMode.LastMessaged;
//   const periodHours = parseInt(data?.[ATTRIBUTION_MODE_HOURS_FIELD] ?? '', 10); // returns number or NaN

//   if (
//     isLastMessagedAttributionMode &&
//     (periodHours < MIN_CONVERSIONS_PERIOD_HOUR || periodHours > MAX_CONVERSIONS_PERIOD_HOUR)
//   ) {
//     ctx.addIssue({
//       code: z.ZodIssueCode.custom,
//       message: CAMPAIGN_ERROR_MESSAGES.invalidAttributionPeriodRange,
//       path: [ATTRIBUTION_MODE_HOURS_FIELD],
//     });
//   }
// });
